import LanguageDetector from "i18next-browser-languagedetector";

export const languageDetector = new LanguageDetector();

languageDetector.init({
  languageUtils: {},
});

// MiBoard is currently offered only in Brazilian Portuguese. This deliberately
// ignores browser and previously cached language preferences.
export const getPreferredLanguage = () => "pt-BR";
